import React from "react";
import "./RegistrationSuccessModal.css";

interface RegistrationSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    onNavigateToDashboard: () => void;
    title?: string;
    description?: string;
    buttonText?: string;
}

const RegistrationSuccessModal: React.FC<RegistrationSuccessModalProps> = ({
    isOpen,
    onClose,
    onNavigateToDashboard,
    title = "Registration Complete",
    description = "Your account has been successfully created. You can now access your dashboard.",
    buttonText = "Go to Sign In"
}) => {
    if (!isOpen) return null;

    return (
        <div className="registration-modal-overlay">
            <div className="registration-modal-container">
                {/* Glowing Checkmark Icon with Particles */}
                <div className="registration-checkmark-container">
                    {/* Outer glow rings */}
                    <div className="registration-glow-ring registration-glow-ring-1"></div>
                    <div className="registration-glow-ring registration-glow-ring-2"></div>
                    <div className="registration-glow-ring registration-glow-ring-3"></div>

                    {/* Particle effects */}
                    <div className="registration-particle registration-particle-1">✦</div>
                    <div className="registration-particle registration-particle-2">✦</div>
                    <div className="registration-particle registration-particle-3">✦</div>
                    <div className="registration-particle registration-particle-4">✦</div>
                    <div className="registration-particle registration-particle-5">✦</div>
                    <div className="registration-particle registration-particle-6">✦</div>

                    {/* Main checkmark circle */}
                    <div className="registration-checkmark-circle">
                        <svg
                            className="registration-checkmark-icon"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5 13l4 4L19 7"
                                stroke="white"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </div>

                {/* Title */}
                <h2 className="registration-modal-title">{title}</h2>

                {/* Description */}
                <p className="registration-modal-description">
                    {description}
                </p>

                {/* Action Button */}
                <button
                    className="registration-dashboard-button"
                    onClick={onNavigateToDashboard}
                >
                    {buttonText}
                </button>

                {/* Close Link */}
                {/* <button className="registration-close-link" onClick={onClose}>
                    Close
                </button> */}
            </div>
        </div>
    );
};

export default RegistrationSuccessModal;
